import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import ViewerPage from '@/views/ViewerPage.vue'
import PricingPage from '@/views/PricingPage.vue'
import BlogPage from '@/views/BlogPage.vue'
import BlogPostPage from '@/views/BlogPostPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/viewer',
    name: 'Viewer',
    component: ViewerPage,
    props: route => ({
      dxfUrl: route.query.dxfUrl,
      title: route.query.title,
      showLayer: route.query.showLayer === 'true'
    })
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: PricingPage
  },
  {
    path: '/blog',
    name: 'Blog',
    component: BlogPage
  },
  {
    path: '/blog/:id',
    name: 'BlogPost',
    component: BlogPostPage,
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫 - 允许直接访问viewer页面，即使没有dxfUrl参数
router.beforeEach((to, from, next) => {
  next()
})

export default router